import React, { useState } from "react";
import { useElements, useStripe, CardElement } from '@stripe/react-stripe-js';
import { Button, FormControl, Paper, FormHelperText } from "@mui/material";
import { useSnackbar } from "notistack";
import useAPI from "../../../utils/api";
import Loader from "react-loader-spinner";

export default function UpdateCreditCard({ onUpdate, onCancel }) {
  const [loading, setLoading] = useState(false);
  const stripe = useStripe();
  const elements = useElements();
  const { enqueueSnackbar } = useSnackbar();
  const API = useAPI();

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    const cardElement = elements.getElement(CardElement);
    setLoading(true);
    // Use your card Element with other Stripe.js APIs
    const {error, paymentMethod} = await stripe.createPaymentMethod({
      type: 'card',
      card: cardElement,
    });

    if (error) {
      enqueueSnackbar(error.message, { variant: 'error' });
    } else {
      const [ok, response] = await API.updateCreditCard(paymentMethod.id);
      if (ok) {
        const { brand, last4, exp_month, exp_year } = paymentMethod.card;
        onUpdate({ brand, last4, exp_month, exp_year }, paymentMethod);
        enqueueSnackbar("Credit Card successfully updated.", { variant: 'success' });
      } else {
        enqueueSnackbar(response?.message || response.error, { variant: 'error' });
      }
    }
    setLoading(false);
  };

  const label = loading ? <Loader height={10} visible={loading} type="ThreeDots" color="white"/> : 'Save';

  return (
    <React.Fragment>
      <form onSubmit={handleSubmit}>
        <div style={{ padding: '4px' }}>
          <FormControl className="StripeElement--wrapper">
            <div style={{ padding: '12px', border: '1px solid #cbd5e1', borderRadius: '6px', backgroundColor: '#ffffff' }}>
              <CardElement onReady={element => element.focus()} />
            </div>
            <FormHelperText id="my-helper-text"></FormHelperText>
          </FormControl>
          <div style={{ display: 'flex', gap: '12px', marginTop: '8px' }}>
            <Button color="primary" variant="contained" onClick={handleSubmit}>{label}</Button>
            <Button variant="outlined" onClick={onCancel} style={{ color: '#475569', borderColor: '#cbd5e1' }}>Cancel</Button>
          </div>
        </div>
      </form>
    </React.Fragment>
  );
}
